import React from 'react';
import { toast, ToastContentProps, ToastPosition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TypeError } from '../types/enums';

/** Schedule placement/swap info toast with optional Undo (bottom-right by default from caller). */
export const scheduleActionInfoWithUndo = (
    message: string,
    position: ToastPosition,
    onUndo: () => void,
    undoLabel: string
) => {
    const Content = ({ closeToast }: ToastContentProps<unknown>) => (
        <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
            <span style={{ flex: '1 1 auto', textAlign: 'left' }}>{message}</span>
            <button
                type="button"
                className="btn btn-sm btn-outline-primary flex-shrink-0"
                onClick={() => {
                    onUndo();
                    closeToast?.();
                }}
            >
                {undoLabel}
            </button>
        </div>
    );
    toast.info(Content, { position, autoClose: 3000 });
};

export const scheduleActionSuccessWithUndo = (
    message: string,
    position: ToastPosition,
    onUndo: () => void,
    undoLabel: string
) => {
    const Content = ({ closeToast }: ToastContentProps<unknown>) => (
        <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
            <span style={{ flex: '1 1 auto', textAlign: 'left' }}>{message}</span>
            <button
                type="button"
                className="btn btn-sm btn-outline-success flex-shrink-0"
                onClick={() => {
                    onUndo();
                    closeToast?.();
                }}
            >
                {undoLabel}
            </button>
        </div>
    );
    toast.success(Content, { position, autoClose: 3000 });
};

export const Notification = (
    type: TypeError,
    message: string,
    position: ToastPosition = 'top-right'
) => {
    const autoClose = 3000;
    switch (type) {
        case TypeError.info:
            toast.info(message, {
                position,
                autoClose,
            });
            break;
        case TypeError.success:
            toast.success(message, {
                position,
                autoClose,
            });
            break;
        case TypeError.warning:
            toast.warning(message, {
                position,
                autoClose,
            });
            break;
        case TypeError.error:
            toast.error(message, {
                position,
                autoClose,
            });
            break;
    }
};
